import {
  FULFILLMENT_STATUSES,
  ORDER_METHODS,
  PaymentMethods,
  REFUND_REASONS,
  ROOM_SERVICE_LOCATION_TYPES,
} from '../../../../../services/exports/Constants';
import { OFFER_KIND } from '../../../../../views/menu/offers/constants';

export default {
  title: 'Besteldetails',
  sections: {
    driver_info: 'Bezorgerinfo',
    order_info: 'Bestelinformatie',
    price_info: 'Prijsinformatie',
    adjustments: 'Aanpassingen',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Meenemen',
    [ORDER_METHODS.delivery]: 'Bezorging',
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Roomservice',
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Tafelservice',
  },
  room_service_location_types: {
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: {
      details_label: 'Kamernummer',
    },
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: {
      details_label: 'Tafelnummer',
    },
  },
  fulfillment_statuses: {
    [FULFILLMENT_STATUSES.created]: 'Deze bestelling wacht op goedkeuring',
    [FULFILLMENT_STATUSES.reviewed]: 'Deze bestelling wacht op goedkeuring',
    [FULFILLMENT_STATUSES.accepted]: 'Deze bestelling wordt momenteel verwerkt',
    [FULFILLMENT_STATUSES.preparing]: 'Deze bestelling wordt momenteel verwerkt',
    [FULFILLMENT_STATUSES.ready]: 'Deze bestelling is klaar om door de klant afgehaald te worden',
    [FULFILLMENT_STATUSES.on_delivery]: 'Deze bestelling wordt bezorgd bij de klant',
    [FULFILLMENT_STATUSES.picked]: 'Deze bestelling is succesvol afgehandeld',
    [FULFILLMENT_STATUSES.rejected]: 'Deze bestelling is afgewezen en terugbetaald',
    default: 'Deze bestelling is succesvol afgehandeld',
  },
  adjustment_reasons: {
    [REFUND_REASONS.RequestedByCustomer]: 'Aangevraagd door klant',
    [REFUND_REASONS.Reclamation]: 'Reclamatie',
    [REFUND_REASONS.CommunicationError]: 'Communicatiefout',
    [REFUND_REASONS.Other]: 'Overig',
    [REFUND_REASONS.Dispute]: 'Klantgeschil',
    dispute_win: 'Klantgeschil gewonnen',
    null: '',
    undefined: '',
  },
  labels: {
    order_note: 'Bestelnotitie',
    discount: 'Korting',
    driver_name: 'Naam bezorger',
    driver_phone_number: 'Telefoon bezorger',
    pin_code: 'PIN',
    invoice_payment: 'Betaling via factuur',
    paid_in_cash: 'Contante betaling',
    customer_paid_online: 'Klant heeft online betaald',
    phone: 'Tel',
    email: 'E-mail',
    points_used: 'Deze bestelling bevat een loyaliteitsbeloning ingewisseld door een vaste klant',
    delivery: 'Bezorging',
    pickup: 'Afhalen',
    original: 'Origineel',
    delivery_fee: 'Bezorgkosten',
    tip: 'Fooi',
    service_fee: 'Online verwerking',
    payment_method_upcharge_fee: {
      [PaymentMethods.PAYPAL]: 'PayPal-kosten',
    },
    discount_breakdown: {
      [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: 'Percentagekorting op totaal toegepast',
      [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: 'Percentagekorting op producten toegepast',
      [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: 'Bedragkorting op producten toegepast',
      [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: 'Bedragkorting op totaal toegepast',
      [OFFER_KIND.BOGO]: 'Bogo toegepast',
      [OFFER_KIND.BOGO_HALF_PRICE]: 'Bogo halve prijs toegepast',
      [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Gratis artikel op producten toegepast',
      [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Gratis artikel op totaal toegepast',
      GiftCard: 'Cadeaukaart toegepast',
      Reward: 'Spaarpunten toegepast',
      CashbackAccount: 'Spaarpunten toegepast',
      PromoCodeComponent: 'Promo toegepast',
      Offer: 'Aanbieding toegepast',
    },
    total_discount: 'Promo toegepast',
    tax: 'Belastingen',
    total: 'Totaal',
    today: 'Vandaag',
  },
  schedule: {
    header: 'Gepland voor {{date}}, {{time}}',
    text: 'We herinneren u wanneer het tijd is om de bestelling voor te bereiden',
  },
};
